import { render, staticRenderFns } from "./InspectionPictureInPictureAnomaly.vue?vue&type=template&id=b4477ee6&scoped=true&"
import script from "./InspectionPictureInPictureAnomaly.vue?vue&type=script&lang=ts&"
export * from "./InspectionPictureInPictureAnomaly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4477ee6",
  null
  
)

export default component.exports